import * as React from 'react'

import {useAppSelector} from '../hooks/redux'

import {Permission} from '../types'

interface Props {
  children: React.ReactNode
  requiredPermissions: Permission[]
}

const RequireAuthPartial = ({requiredPermissions, children}: Props) => {
  const authUser = useAppSelector(state => state.auth.user)

  if (!!authUser && requiredPermissions.includes(authUser.permission)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return null
}

export default RequireAuthPartial
